import { FaceIconSmiley } from '~/@mid_ui/icons/FaceIconSmiley'
import { FaceIconSad } from '~/@mid_ui/icons/FaceIconSad'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { ProgressCircle } from '~/@mid_ui/progress-circle/ProgressCircle'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useInvestorAnalysisStore } from '../stage-analysis/useInvestorAnalysisStore'
import { getInvestorAnalysisVersion } from '../analysis-versions/investorAnalysisVersions'

function InvestorAnalysisSideProgress() {
  const { steps, useSophisticatedTestStore, useUnsophisticatedTestStore } =
    getInvestorAnalysisVersion()
  const isDesktop = useIsDesktop()
  const { user } = useUser()
  const analysisStore = useInvestorAnalysisStore(user?._id ?? null)
  const { currentStepIndex: unsophisticatedCurrentStepIndex } =
    useUnsophisticatedTestStore(user?._id ?? null)

  const { currentStepIndex: sophisticatedCurrentStepIndex } =
    useSophisticatedTestStore(user?._id ?? null)

  if (!isDesktop) return null

  if (!analysisStore.finishedScreen) {
    if (analysisStore.stage === 'assessExperience') return null

    if (analysisStore.stage === 'sophisticated') {
      return (
        <ProgressCircle
          currentStep={sophisticatedCurrentStepIndex + 1}
          totalSteps={steps.sophisticated.length}
        />
      )
    }

    if (analysisStore.stage === 'experienced') {
      return (
        <ProgressCircle
          currentStep={unsophisticatedCurrentStepIndex + 1}
          totalSteps={steps.experienced.length}
        />
      )
    }

    if (analysisStore.stage === 'inexperienced') {
      return (
        <ProgressCircle
          currentStep={unsophisticatedCurrentStepIndex + 1}
          totalSteps={steps.inexperienced.length}
        />
      )
    }

    if (analysisStore.stage === 'lowTestScore') {
      return <FaceIconSad />
    }

    return null
  }

  if (analysisStore.finishedScreen === 'sophisticated') {
    return <FaceIconSmiley />
  }

  if (analysisStore.finishedScreen === 'unsophisticated') {
    return <FaceIconSad />
  }

  return null
}

export { InvestorAnalysisSideProgress }
